<template>
  <div
    class="benefits"
    :class="mobileOnly"
  >
    <div class="benefits__inner">
      <p class="benefits__header">
        Benefits of Completing Your Application Now
      </p>

      <div
        v-for="(benefit, index) in benefits"
        :key="index"
        class="benefits__list-item"
      >
        <FontAwesomeIcon
          icon="chevron-right"
          :class="textColorClass()"
          class="benefits__icon"
        />
        {{ benefit }}
      </div>
    </div>
  </div>
</template>

<script>
import theme from '@/mixins/theme'

export default {
  name: 'Benefits',

  // Mixins
  mixins: [
    theme
  ],

  // Props
  props: {
    mobile: {
      type: Boolean,
      default: false
    }
  },

  // Data
  data () {
    return {
      benefits: [
        'No branch visits required',
        'Completing an application doesn’t affect your credit score',
        'Get your money within 24 hours'
      ]
    }
  },

  computed: {
    mobileOnly () {
      return this.mobile ? 'sm:hidden' : ''
    }
  }
}
</script>
<style scoped lang="scss">
  .benefits {
    @apply max-w-450 m-auto py-40 px-20;

    &__inner {
      @apply flex flex-col items-center;
    }

    &__header {
      @apply font-semibold mb-10 text-sm;

      @screen sm {
        @apply text-center text-base;
      }
    }

    &__list-item {
      @apply my-5 text-sm flex items-start max-w-300 w-full;

      @screen sm {
        @apply text-base pl-20;
      }
    }

    &__icon {
      @apply mr-20 mt-[4px];
    }
  }
</style>
